import { defineMessages } from 'react-intl';

export default defineMessages({
  enterNumber: {
    id: 'NumberValueEditor.enterNumber',
    defaultMessage: 'Enter a number',
  },
});
